/**
 * Scroll Position Utilities
 * Robustes Auslesen des Dokument-Scroll-Offsets.
 */

/**
 * Liefert den aktuellen vertikalen Scroll-Offset des Dokuments,
 * unabhaengig davon, ob html, body oder documentElement der echte
 * Scroll-Container ist.
 *
 * Hintergrund: Auf iOS WKWebView macht die Capacitor-CSS-Regel
 * (html UND body: height:100% + overflow-y:auto, siehe index.css) den
 * body zum Scroll-Container. Dann bleiben window.scrollY und
 * document.documentElement.scrollTop konstant 0, waehrend
 * document.body.scrollTop den echten Wert haelt. Auf der Landing Page
 * (html.landing-page-html) bzw. im Desktop-Browser ist window.scrollY
 * korrekt. Math.max ueber alle Quellen deckt jeden Fall ab.
 *
 * @returns {number} Scroll-Offset in Pixeln (>= 0)
 */
export const getDocumentScrollTop = () => {
  if (typeof window === 'undefined') return 0;
  const doc = document.scrollingElement || document.documentElement;
  return Math.max(
    window.scrollY || 0,
    doc ? doc.scrollTop || 0 : 0,
    document.body ? document.body.scrollTop || 0 : 0
  );
};

/**
 * Scrollt das Dokument zuverlaessig nach ganz oben.
 *
 * Gegenstueck zu getDocumentScrollTop(): Auf iOS WKWebView ist der body
 * der Scroll-Container (html/body: height:100% + overflow-y:auto, siehe
 * index.css), dann bewegt window.scrollTo() allein nichts. Deshalb setzen
 * wir window UND scrollingElement/documentElement/body zurueck.
 *
 * @param {'auto'|'smooth'} [behavior='auto'] Scroll-Verhalten
 */
export const scrollWindowToTop = (behavior = 'auto') => {
  if (typeof window === 'undefined') return;
  try {
    window.scrollTo({ top: 0, left: 0, behavior });
  } catch (error) {
    // Fallback für ältere Browser ohne behavior-Support
    window.scrollTo(0, 0);
  }
  if (document.scrollingElement) document.scrollingElement.scrollTop = 0;
  if (document.documentElement) document.documentElement.scrollTop = 0;
  if (document.body) document.body.scrollTop = 0;
};
